<template>
  <a-card :bordered="false" :class="'cust-erp-sub-tab'">
    <!-- 操作按钮区域 -->
    <div class="table-operator" v-if="mainId">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete" />删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div class="table-container">
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <!-- :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" -->
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :scroll="{ x: true }"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
            <a>删除</a>
          </a-popconfirm>
        </span>
      </a-table>
    </div>

    <okrPlan-modal ref="modalForm" @ok="modalFormOk" :mainId="mainId" :mainRow="mainRow"></okrPlan-modal>
  </a-card>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import OkrPlanModal from './modules/OkrPlanModal'

export default {
  name: 'OkrPlanList',
  mixins: [JeecgListMixin],
  components: { OkrPlanModal },
  props: {
    mainId: {
      type: String,
      default: '',
      required: false,
    },
    mainRow: {
      type: Object,
      required: false,
    },
  },
  watch: {
    mainId: {
      immediate: true,
      handler(val) {
        if (!this.mainId) {
          this.clearList()
        } else {
          this.queryParam['okrSummaryId'] = val
          this.loadData(1)
        }
      },
    },
  },
  data() {
    return {
      description: '双月复盘-总结管理页面',
      disableMixinCreated: true,
      // 表头
      columns: [
        {
          title: '工作计划',
          align: 'center',
          dataIndex: 'content',
        },
        {
          title: '权重',
          align: 'center',
          dataIndex: 'weight',
        },
        {
          title: '虚线汇报对象',
          align: 'center',
          dataIndex: 'facilitatorsText',
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 147,
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: `${window._CONFIG['doBaseUrl']}/doMistServer/okrSummary/listOkrPlanByMainId2`,
        delete: `${window._CONFIG['doBaseUrl']}/doMistServer/okrSummary/deleteOkrPlan`,
        deleteBatch: `${window._CONFIG['doBaseUrl']}/doMistServer/okrSummary/deleteBatchOkrPlan`,
        exportXlsUrl: `${window._CONFIG['doBaseUrl']}/doMistServer/okrSummary/exportOkrPlan`,
        importUrl: `${window._CONFIG['doBaseUrl']}/doMistServer/okrSummary/importOkrPlan`,
      },
      dictOptions: {
        okrGroupId: [],
      },
      superFieldList: [],
    }
  },
  created() {
    this.getSuperFieldList()
  },
  computed: {
    importExcelUrl() {
      return `${window._CONFIG['domianURL']}/${this.url.importUrl}/${this.mainId}`
    },
  },
  methods: {
    clearList() {
      this.dataSource = []
      this.selectedRowKeys = []
      this.ipagination.current = 1
    },
    getSuperFieldList() {
      let fieldList = []
      fieldList.push({ type: 'string', value: 'okrGroupId', text: '复盘时间', dictCode: 'okr_group,name,id' })
      fieldList.push({ type: 'sel_user', value: 'assignner', text: '分配给' })
      fieldList.push({ type: 'sel_user', value: 'reporter', text: '汇报对象' })
      this.superFieldList = fieldList
    },
  },
}
</script>
<style lang="less" scoped>
@import '~@assets/less/common.less';

.table-container /deep/td {
  white-space: pre-wrap;
}
</style>
